import axios from 'axios';
import { API_BASE_URL } from '../constants';

const api = axios.create({
  baseURL: API_BASE_URL,
});

const getHeaders = (accessToken: string) => ({
  'Authorization': `Bearer ${accessToken}`
});

export const getConfig = async () => {
  const response = await api.get('/docs-config');
  return response.data;
};

export const redirectToDocs = async (accessToken: string, docsPath: string) => {
  const response = await api.get(`/docs-url${docsPath}`, { headers: getHeaders(accessToken) });
  window.location.href = response.data;
};
